import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateLabelPipe } from 'src/app/core/pipes/translate-label.pipe';
import { FilterConfig } from './filters.service';

@Component({
  selector: 'app-filters-item',
  templateUrl: './filters-item.component.html',
  styleUrls: ['./filters-item.component.scss'],
  providers: [TranslateLabelPipe],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class FiltersItemComponent {
  @Input() config: FilterConfig;

  @Input() onClick: (filter: FilterConfig) => void;

  onClickItem(): void {
    this.onClick(this.config);
  }
}
